import { useOpenAgentSkill } from "@ext/agent/components/skills/useOpenAgentSkill";
import type { MouseEvent, ReactNode } from "react";

export const AgentSkillLink = ({ skillName, children }: { skillName: string; children: ReactNode }) => {
	const openSkill = useOpenAgentSkill();

	const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();
		event.stopPropagation();
		void openSkill(skillName);
	};

	return (
		<a href={`#${skillName}`} onClick={onClick}>
			{children}
		</a>
	);
};
